import axios from "axios";
import config from "./../config";

export default {
  async list(token, type, amount, offset, scope, { search_query }) {
    return await axios.post(`${config.endpoint}/entities/list`, {
      token,
      type,
      amount,
      offset,
      scope,
      search_query
    });
  },

  async get(token, type, id, scope) {
    return await axios.post(`${config.endpoint}/entities/get`, {
      token,
      type,
      id,
      scope
    });
  },

  async create(token, type, entity, scope) {
    console.log("entities.create");
    return await axios.post(`${config.endpoint}/entities/create`, {
      token,
      type,
      entity,
      scope
    });
  },

  async update(token, type, id, entity) {
    return await axios.post(`${config.endpoint}/entities/update`, {
      token,
      type,
      id,
      entity
    });
  },

  async delete(token, type, id) {
    return await axios.post(`${config.endpoint}/entities/delete`, {
      token,
      type,
      id
    });
  },

  async action(token, type, id, action) {
    return await axios.post(`${config.endpoint}/entities/action`, {
      token,
      type,
      id,
      action
    });
  },

  async fields(token, type, scope) {
    return await axios.post(`${config.endpoint}/entities/fields`, {
      token,
      type,
      scope
    });
  },

  async depended(token, type, field_name, scope) {
    return await axios.post(`${config.endpoint}/entities/depended`, {
      token,
      type,
      field_name,
      scope
    });
  },

  async list_item(token, type, entity) {
    return await axios.post(`${config.endpoint}/entities/list_item`, {
      token,
      type,
      entity
    });
  }
};
